<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <p @click="$router.go(-1)" class="back">back</p>
      <md-card>
        <md-card-content v-if="advertisement" class="md-layout md-gutter">
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Advertisement Name</label>
              <md-input v-model="advertisement.name" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Company Name</label>
              <md-input v-model="advertisement.company" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Media Type</label>
              <md-select v-model="is_video">
                <md-option value="false">Image File</md-option>
                <md-option value="true">Video File</md-option>
              </md-select>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div v-if="!advertisement.video" class="md-layout-item md-size-50">
            <md-field class="num-small">
              <label>Duration (seconds)</label>
              <md-input
                v-model="advertisement.duration"
                type="number"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <div class="input">
              <label>Advertisement File</label>
              <upload
                title="an Event Image"
                :media="advertisement.url"
                @addMedia="addMedia($event, 'url')"
                @removeMedia="removeMedia()"
                @removeImage="advertisement.event_image = null"
              ></upload>
              <span class="md-helper-text">Required</span>
            </div>
          </div>
          <!-- <div class="md-layout-item md-size-50">
            <md-field>
              <label></label>
              <md-input
                class="file-upload-form"
                v-model="advertisement.file"
                type="file"
                id="advertFile"
                @change="previewImage" 
                accept="video/*,image/*"
              ></md-input> 
            </md-field>
            <div class="image-preview" v-if="imageData.length > 0">
              <img class="preview" :src="imageData">
            </div> -->
          <!-- </div> -->
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <md-button class="md-primary md-round md-small" @click="validate()"
            >Save</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { db } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import firebase from "firebase/app";
import Upload from "@/components/Upload.vue";

export default {
  components: {
    upload: Upload
  },
  data() {
    return {
      imageData: "", // we will store base64 format of image in this string
      is_video: false,
      batch: db.batch(),
      selectedFile: null,
      advertisement: {
        name: null,
        company: null,
        video: false,
        url: null,
        duration: 60,
        created: Date.now()
      },
      stores: []
    };
  },
  firestore: {
    stores: db.collection("advertisement")
  },
  created() {
    let advertisementId = this.$route.params.advertisement_id;
    let advertisementTemplate = Object.assign({}, this.advertisement);

    this.$bind(
      "advertisement",
      db.collection("advertisement").doc(advertisementId)
    ).then(() => {
      if (!this.advertisement) {
        this.advertisement = advertisementTemplate;
      }
    });
  },
  methods: {
    addMedia(url, key) {
      this.advertisement[key] = url;
    },
    removeMedia() {
      this.advertisement.url = null;
    },
    validate() {
      let valid = true;
      for (let k in this.advertisement) {
        if (!this.advertisement[k] && k != "video") {
          valid = false;
          console.log(k);
        }
      }

      if (valid) {
        this.save();
      } else {
        return Swal.fire("Missing Fields", "Please enter all required fields");
      }
    },
    save() {
      let vm = this;
      return db
        .collection("advertisement")
        .doc(this.$route.params.advertisement_id)
        .set(vm.advertisement, { merge: true })
        .then(() => {
          this.batch.commit();
        })
        .then(() => {
          this.batch = db.batch();
          Swal.fire("Success", "Page Updated", "success").then(() => {
            this.$router.go(-1);
          });
        });
    }
  },
  watch: {
    is_video() {
      if (this.is_video == "false") this.advertisement.video = false;
      else this.advertisement.video = true;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
